 
 
 
 
 
 
/* jshint nomen:false */
define(['leaflet', './vectorLayer', '../labelsLayerMixinFactory'],
    function(L, VectorLayer, labelsLayerMixinFactory) {
        'use strict';

        var TomTomVectorLabelsLayer = VectorLayer.extend({
            name: 'vectorLabels',
            onAdd: function(map) {
                VectorLayer.prototype.onAdd.call(this, map);
                this._bringToFront(map);
            },
            _bringToFront: function(map) {
                var pane = map._panes.overlayPane;
                this._setPane(pane);
                if (this._glContainer) {
                    pane.appendChild(this._glContainer);
                }
                return this;
            },
            initialize: function(options) {
                options = L.extend({}, options);
                options.layer = 'labels';
                VectorLayer.prototype.initialize.call(this, options);
            },
            updateOptions: function(options) {
                if (options.style) {
                    options = L.extend({}, options, {layer: 'labels'});
                    VectorLayer.prototype.updateOptions.call(this, options);
                }
            }
        });

        L.TomTomVectorLabelsLayer = TomTomVectorLabelsLayer.extend(labelsLayerMixinFactory('vector'));

        L.tomTomVectorLabelsLayer = function(options) {
            return new L.TomTomVectorLabelsLayer(options);
        };

        return L.TomTomVectorLabelsLayer;
    });



// WEBPACK FOOTER //
// ./display/layers/vector/vectorLabelsLayer.js